import React from 'react';

const Uppercase = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M6.289 8.549L4.628 13H7.951L6.289 8.549ZM11.58 17H9.445L8.698 15H3.881L3.134 17H1L5.106 6H7.472L11.58 17ZM17.789 8.549L16.128 13H19.451L17.789 8.549ZM23.08 17H20.945L20.198 15H15.381L14.634 17H12.5L16.606 6H18.972L23.08 17Z"
      fill="currentColor"
    />
  </svg>
);

export default Uppercase;
